<template>
  <!------新增弹框------>
  <dialogWrap
    :dialogShow="handelDialogVisible"
    :title="dialogTitle"
    :before-close="closeDialog"
    :width="'824px'"
  >
    <el-form
      :model="formData"
      ref="formData"
      label-width="140px"
      :rules="serviceRules"
      class="formData"
      :disabled="isDisabled"
    >
      <el-form-item class="mt5" v-if="type!=='edit'" label="营业执照:" label-width="150px">
        <div class="upload">
          <UploadCommon
            :fileList="businessLicenseImgList"
            ref="drivingMainRef"
            fileTitle="营业执照"
            :isAlone="true"
            @uploadSuccess="businessLicenseImgMainSuccess"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_business_license_toOcr"
          />
        </div>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="服务商名称:">
            <el-input v-model="formData.name" placeholder="请输入" clearable v-deleteEmoji></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="serviceType" label="服务类型:">
            <el-select placeholder="请选择" v-model="formData.serviceType" clearable :disabled="!!serviceTypeProp">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="contacts" label="联系人:">
            <el-input
              v-space="true"
              v-model="formData.contacts"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="contactTel" label="联系电话:">
            <el-input
              v-number:phone
              v-model="formData.contactTel"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="creditCode" label="统一社会信用代码:">
            <el-input
              v-model="formData.creditCode"
              placeholder="请输入"
              maxlength="18"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="accountName" label="账户名称:">
            <el-input v-model.trim="formData.accountName" placeholder="请输入" clearable v-deleteEmoji />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="accountNo" label="开户账号:">
            <el-input v-model="formData.accountNo" placeholder="请输入" v-number:integer.noTrim="20" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="bankName" label="开户银行:">
            <el-input v-model.trim="formData.bankName" placeholder="请输入" clearable v-deleteEmoji />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="address" label="客户地址:">
            <el-input
              type="textarea"
              v-model="formData.address"
              placeholder="请输入"
              clearable
              v-deleteEmoji
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-collapse v-model="activeNames">
        <el-collapse-item :title="collapseTitle" name="1">
          <el-row class="mt16">
            <el-col :span="12">
              <el-form-item prop="expireDate" label="服务到期时间:">
                <el-date-picker
                  v-model="formData.expireDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  format="yyyy-MM-dd"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="companyName" label="单位名称:">
                <el-input v-model="formData.companyName" placeholder="请输入" clearable v-deleteEmoji />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="legalPersonName" label="法人姓名:">
                <el-input
                  v-model="formData.legalPersonName"
                  placeholder="请输入"
                  clearable
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="idCardNo" label="法人身份证号:">
                <el-input
                  v-model="formData.idCardNo"
                  maxlength="18"
                  placeholder="请输入"
                  clearable
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="taxType" label="税票类型:">
                <el-select placeholder="请选择" v-model="formData.taxType" clearable>
                  <el-option
                    v-for="item in taxTypeList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="taxNo" label="税号:">
                <el-input v-model="formData.taxNo" placeholder="请输入" clearable v-deleteEmoji />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="registration" label="登记机关:">
                <el-input v-model="formData.registration" placeholder="请输入" clearable v-deleteEmoji />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="businessRegistrationNo" label="工商注册号:">
                <el-input
                  v-model="formData.businessRegistrationNo"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="organizationCode" label="组织机构代码:">
                <el-input
                  v-model="formData.organizationCode"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="registeredAddress" label="注册地址(OCR):">
                <el-input
                  type="text"
                  v-model="formData.registeredAddress"
                  placeholder="请输入"
                  clearable
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="remarks" label="备注">
                <el-input
                  type="textarea"
                  v-model="formData.remarks"
                  placeholder="请输入"
                  clearable
                  v-deleteEmoji
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="type==='edit'" class="mt5" label="营业执照:" label-width="150px">
            <div class="upload">
              <UploadCommon
                :fileList="businessLicenseImgList"
                ref="drivingMainRef"
                fileTitle="营业执照"
                :isAlone="true"
                @uploadSuccess="businessLicenseImgMainSuccess"
                :sizeType="4"
                commonUpload
                group="assert"
                code="assert_business_license_toOcr"
              />
            </div>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <template #footer>
      <div class="mt16" style="text-align: right">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="!isDisabled"
          @click="submit"
          type="primary"
          size="small"
          :loading="loading"
        >确认{{type==='edit'?'编辑':'新增'}}</el-button>
      </div>
    </template>
  </dialogWrap>
</template>
<script>
import { providerAdd, providerEdit } from '@/api/domain/organize'
import SelectOption from '@/store/dict/selectOptionDict'
import { getIdentity, validateAccountCustomerName, validateEng_Num } from '@/utils/extendFormVaildate'

const TYPE = {
  // 新增
  add: 'add',
  // 编辑
  edit: 'edit',
}

export default {
  name: 'handleProvider',
  props: {
    type: {
      type: String,
      default: TYPE.add,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
    serviceTypeProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDisabled: false,
      activeNames: ['1'],
      businessLicenseImgList: [],
      formData: {
        id: '',
        name: '',
        serviceType: '',
        contacts: '',
        contactTel: '',
        expireDate: '',
        companyName: '',
        creditCode: '',
        legalPersonName: '',
        address: '',
        remarks: '',
        accountNo: '', // 开户账号
        accountName: '', // 账户名称
        businessLicenceUrl: '', // 营业执照url
        idCardNo: '', // 法人身份证号码
        bankName: '', // 开户银行名称
        taxType: '', // 税票类型
        taxNo: '', // 税号
        registration: '', // 登记机关
        businessRegistrationNo: '', // 工商注册号
        organizationCode: '', // 组织机构代码
        registeredAddress: '', // 注册地址(OCR
      },
      serviceRules: {
        name: [
          { required: true, message: '服务商名称不能为空', trigger: 'blur' },
          { validator: validateAccountCustomerName, trigger: 'blur' },
        ],
        serviceType: [
          { required: true, message: '服务类型不能为空', trigger: 'change' },
        ],
        contacts: [
          { required: true, message: '联系人不能为空', trigger: 'blur' },
          { validator: validateAccountCustomerName, trigger: 'blur' },
        ],
        contactTel: [
          { required: true, min: 11, max: 11, message: '格式不正确', trigger: 'blur' },
        ],
        // 法人姓名
        legalPersonName: [
          { validator: validateAccountCustomerName, trigger: 'blur' },
        ],
        idCardNo: [
          { validator: getIdentity, trigger: 'blur' },
        ], // 统一社会信用代码
        creditCode: [
          { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' },
          { validator: getIdentity, trigger: 'blur' },
        ],
        accountName: [
          { required: true, message: '账户名称不能为空', trigger: 'blur' }, // 账户名称
        ],

        accountNo: [
          { required: true, message: '开户账号不能为空', trigger: 'blur' }, // 开户账号
        ],

        bankName: [
          { required: true, message: '开户银行不能为空', trigger: 'blur' }, // 开户银行
        ],
        address: [
          { required: true, message: '客户地址不能为空', trigger: 'blur' }, // 客户地址
        ],
        businessRegistrationNo: [
          { validator: validateEng_Num, trigger: 'blur' }, // 工商注册号
        ],
        organizationCode: [
          { validator: validateEng_Num, trigger: 'blur' }, // 组织机构代码
        ],
      },
      loading: false,
      handelDialogVisible: false,
    }
  },
  computed: {
    // 服务商类型
    typeList() {
      return this.dictParseList(SelectOption.serviceProviderTypeDict)
    },
    // 税票类型
    taxTypeList() {
      return this.dictParseList(SelectOption.taxTypeList)
    },
    // 标题
    dialogTitle() {
      if (this.isDisabled) return '服务商详情'
      if (this.type === TYPE.edit) return '编辑服务商'
      return '新增服务商'
    },
    // 折叠标题
    collapseTitle() {
      return `${this.activeNames.length > 0 ? '收起' : '展开'} (以下内容为选填)`
    },
  },
  methods: {
    // orc成功事件
    businessLicenseImgMainSuccess(url) {
      this.formData.businessLicenceUrl = url
    },
    submit() {
      this.$refs.formData.validate((valid) => {
        this.formData.businessLicenceUrl = this.getUoloadCommonFileData(this.businessLicenseImgList)
        if (valid) {
          this.type === TYPE.add ? this.addService(this.formData) : this.submitEdit(this.formData)
        }
      })
    },
    // 新增保存
    async addService(val) {
      this.loading = true
      providerAdd(val).then((res) => {
        const { code } = res || {}
        if (code === 1) {
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.closeDialog()
          this.$emit('handleSuccess')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 编辑保存
    async submitEdit(val) {
      this.loading = true
      providerEdit(val).then((res) => {
        const { code } = res || {}
        if (code === 1) {
          this.$message({
            message: '编辑成功',
            type: 'success',
          })
          this.closeDialog()
          this.$emit('handleSuccess')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    closeDialog() {
      this.handelDialogVisible = false
      this.businessLicenseImgList = []
      this.$refs.formData.resetFields()
      this.activeNames = ['1']
      Object.keys(this.formData).forEach((item) => {
        this.formData[item] = ''
      })
    },
  },
  watch: {
    handelDialogVisible(val) {
      if (val && this.type === TYPE.edit) {
        if (this.editData.businessLicenceUrl) {
          this.businessLicenseImgList = this.getURL({ data: this.editData.businessLicenceUrl, needName: true })
        }

        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = this.editData[key]
        })
      }
      if (val && this.serviceTypeProp) {
        this.formData.serviceType = Number(this.serviceTypeProp)
      }

      if (this.editData.supportUpdate === 2) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.formData {
  ::v-deep .el-input--small {
    width: 200px;
  }
}
.mt5 {
  margin-top: 5px;
}
::v-deep .el-collapse {
  border-bottom: none;
  border-top: none;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
::v-deep .el-collapse-item__header {
  border-top: 1px solid #ececf4;
  border-bottom: none;
  font-size: 14px;
  color: #979899;
}
::v-deep .el-collapse-item__content {
  border-top: 1px solid #ececf4;
  border-bottom: none;
  font-size: 14px;
  color: #979899;
  padding: 0;
}
::v-deep .el-collapse-item__arrow.is-active {
  transform: rotate(-90deg);
}
::v-deep .el-collapse-item__arrow {
  transform: rotate(90deg);
}
</style>
